import BeneficiaryCard from "./BeneficiaryCard";
import BeneficiaryBoxRaise from "./BeneficiaryBoxRaise";

var AvailableComponents = [
    {
        name: 'beneficiaryCard',
        component: BeneficiaryCard
    },
    {
        name: 'beneficiaryBoxRaise',
        component: BeneficiaryBoxRaise
    }
];

export default {
    LoadComponent: function(name) {
        return AvailableComponents.find(el => el.name.toLowerCase() === name.toLowerCase()).component;
    }    
}